import Contacts from './Contacts.vue';

export { Contacts };


// WEBPACK FOOTER //
// ./src/modules/home/contacts/index.js